import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { LocationState, SetSelectedRoom,FetchVenues, SetSelectedDelivery } from '@moduurnv2/libs-orderingapp/src/core';
import { Store } from '@ngxs/store';

@Injectable()
export class WJSelectedLocationGuard implements CanActivate {
  constructor(private router: Router, private store: Store) {}
  canActivate(route: ActivatedRouteSnapshot) {
    const selectedLocation = this.store.selectSnapshot(
      LocationState.getSelectedLocation
    );
    
    // if you've already got a selectedLocation then we're good, otherwise, continue to process your table parameter and select a location
    if (selectedLocation) {
      return true;
    } else {
      let table;

      // if table is number 1-99 then set that as the selected room.
      // if table is pickup, then set delivery type equal pickup.
      let queryTable = (route.queryParams && route.queryParams.table) ? route.queryParams.table.replaceAll(' ','+') : undefined;
      // let b64String = decodeURIComponent(route.queryParams.table);

      if(!queryTable){
        this.router.navigate(['emptyTable'])
        return false;
      }



      if (queryTable == 'pickup') {
        //set delivery type to Pickup.
        //DELIVERYTYPE02  = pickup
        this.store.dispatch(new SetSelectedDelivery("DELIVERYTYPE02"));
        //console.log("setselecteddelivery to pickup")
      } else {
        this.store.dispatch(new SetSelectedRoom(table));
      } 

      this.router.navigate(['locations'], {
        queryParamsHandling: 'merge',
        preserveFragment: true,
        queryParams : route.queryParams
      });
      return true;
    }
  }
}
